import React from "react";
import {
  Typography,
  Stack,
  Box,
  Divider,
  Link,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import { Dropdown } from "@mui/base/Dropdown";
import { MenuButton } from "@mui/base/MenuButton";
import { Menu } from "@mui/base/Menu";
import { MenuItem } from "@mui/base/MenuItem";
import { useEffect, useState, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getNewLoginHeaderContent } from "../SharedContextStore/slices/newloginHeaderContent";
import profileIcon from "../assets/images/profile.png";
import mobileLogo from "../assets/logo_Brightspeed_Mobile.png";
import profileMobileLogo from "../assets/images/profile-icon-mobile.png";
import profileDesktopLogo from "../assets/images/profile-icon-desktop.png";
import { LoginHeaderContent } from "../SharedComponents/contents";


const LoginHeader = (props: any) => {
  const css = `
    .base-Popup-root.base-Menu-root{
      z-index: 99999;
    }
    `;
  //const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileProfileOpen, setMobileProfileOpen] = useState(false);
  const [mobileSupportOpen, setMobileSupportOpen] = useState(false);
  const [mobileShopAddonOpen, setMobileShopAddonOpen] = useState(false);
  const [anchorActive, setAnchorActive] = useState(false);
  const [anchorActiveID, setAnchorActiveID] = useState(" ");
  const [checkAvailabilityActive, setCheckAvailabilityActive] = useState(false);
  const [scrollYPosition, setScrollYPosition] = useState(0);
  const scrollRef = useRef<null | HTMLElement>(null);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleProfileToggle = () => {
    setMobileProfileOpen((prevState) => !prevState);
  };
  const anchorTagToggle = (e: any, label: any = "") => {
    setAnchorActiveID(label);
  };
  const anchorCheckAvailability = (e: any) => {
    if (e.currentTarget) setCheckAvailabilityActive(!checkAvailabilityActive);
  };
  const handleSupportToggle = (setter: any) => {
    setter((prevState: any) => !prevState);
  };
  useEffect(() => {
    mobileOpen
      ? document.body.classList.add("menuModalOpen")
      : document.body.classList.remove("menuModalOpen");
  }, [mobileOpen]);

  const dispatch = useAppDispatch();
  const loginHeaderContent : any = LoginHeaderContent()

  useEffect(() => {
    getContent();
  }, []);

  const getContent = async () => {
    await dispatch(getNewLoginHeaderContent());
  };

  const HEADER_CONTENT_TOP_NAVIGATION =
    loginHeaderContent?.entry?.top_navigation?.support;
  const HEADER_CONTENT_BOTTOM_NAVIGATION =
    loginHeaderContent?.entry?.bottom_navigation?.home_links;

  // const handleUrlCall = (value: string) => {
  //     window.open(value, "");
  //   };

  //const container = window !== undefined ? () => window().document.body : undefined;
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleScroll = () => {
    const headerReff: any = scrollRef?.current;
    const newScrollYPosition = window.pageYOffset;
    setScrollYPosition(newScrollYPosition);
    if (newScrollYPosition >= headerReff?.offsetTop) {
      headerReff?.classList.add("stickyHeader");
    } else {
      headerReff?.classList.remove("stickyHeader");
    }
  };

  const [findSupportDropdownOpen, setFindSupportDropdownOpen] = useState(false);
  const findSupportButtonRef = useRef<HTMLButtonElement>(null);
  const [myBrightspeedDropdownOpen, setMyBrightspeedDropdownOpen] = useState(false);
  const myBrightspeedButtonRef = useRef<HTMLButtonElement>(null);
  const [shopAddOnDropdownOpen, setShopAddOnDropdownOpen] = useState(false);
  const shopAddOnButtonRef = useRef<HTMLButtonElement>(null);

  const handlefindSupportKeyDown = (event: React.KeyboardEvent<HTMLLIElement>, index: number) => {
    const lastIndex = HEADER_CONTENT_BOTTOM_NAVIGATION?.findsupport?.links?.length - 1;
    if (index === lastIndex && event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      findSupportButtonRef.current?.focus();
      setFindSupportDropdownOpen(false);
    }
  };
  

  const handleMyBrightspeedKeyDown = (event: React.KeyboardEvent<HTMLLIElement>, index: number) => {
    const lastIndex = HEADER_CONTENT_BOTTOM_NAVIGATION?.mybrightspeed?.links?.length - 1;
    if (index === lastIndex && event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      myBrightspeedButtonRef.current?.focus();
      setMyBrightspeedDropdownOpen(false)
    }
  };

  const handleShopAddOnKeyDown = (event: React.KeyboardEvent<HTMLLIElement>, index: number) => {
    const lastIndex = HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_add_ons?.links?.length - 1;
    if (index === lastIndex && event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      shopAddOnButtonRef.current?.focus();
      setShopAddOnDropdownOpen(false);
    }
  };

  return (
    <Stack>
      <style>{css}</style>
      {loginHeaderContent?.entry && (
        <header role="banner">
        <Stack className="loginHeader noPrint">
          <Box className="loginHeaderContainer">
            <Box className="topRow">
              <Box className="main">
                <Box sx={{ display: "flex" }}>
                  <CssBaseline />
                  <AppBar component="nav" role="navigation">
                    <Box className="brspdMobileLogo">
                      <a href="https://www.brightspeed.com/#">
                        <img src={mobileLogo} alt="Brightspeed Logo"></img>
                      </a>
                    </Box>
                    <Toolbar>
                      <IconButton
                        color="inherit"
                        // aria-label="open drawer"
                        aria-label="Toggle navigation"
                        aria-haspopup="true" 
                        edge="start"
                        onClick={handleDrawerToggle}
                        aria-expanded={mobileOpen ? "true" : "false"}  
                      >
                        <Box
                          className={
                            mobileOpen ? "menuIcon menuCloseIcon" : "menuIcon"
                          }
                         
                        />
                        {/* <MenuIcon/> */}
                      </IconButton>

                      <Box className="topnav" role="list">
                        <Box className="topnavLeftLinks">
                          {HEADER_CONTENT_TOP_NAVIGATION.links?.map(
                            (link: any, i: any) => {
                              if (i < 2) {
                                return (
                                  <React.Fragment key={link.href+i}>                                    
                                   <a 
                                      href={link.href}
                                      onClick={(event: any) =>
                                        anchorTagToggle(event, i)
                                      }
                                      className={
                                        anchorActiveID == i ? "linkActive" : ""
                                      }                                     
                                    >
                                      {link.label}
                                    </a>
                                  <Divider orientation="vertical" flexItem role="presentation"/>
                                  </React.Fragment>
                                );
                              }
                            }
                          )}
                          {/* <a href={HEADER_CONTENT_TOP_NAVIGATION.links[0].href}>
                              {HEADER_CONTENT_TOP_NAVIGATION.links[0].label}
                            </a>
                            <Divider orientation="vertical" flexItem role="presentation" />
                            <a href={HEADER_CONTENT_TOP_NAVIGATION.links[1].href}  onClick={(event: any) => anchorTagToggle(event,HEADER_CONTENT_TOP_NAVIGATION?.links[1]?.label)} className={(anchorActiveID==HEADER_CONTENT_TOP_NAVIGATION?.links[1]?.label) ? "linkActive" : ""}>
                              {HEADER_CONTENT_TOP_NAVIGATION.links[1].label}
                            </a> */}
                        </Box>
                        <Box className="topnavRightLinks">
                          {/* Removed Check Availability as per new requirement - May 2025 */}
                          {/* <Box  role="listitem"                            
                            onClick={(event: any) =>
                              anchorCheckAvailability(event)
                            }
                            className={
                              checkAvailabilityActive
                                ? "checkAvailability chacklinkActive"
                                : "checkAvailability"
                            }
                          >
                            <a                      
                              href={HEADER_CONTENT_TOP_NAVIGATION.links[2].href}
                            >
                              {HEADER_CONTENT_TOP_NAVIGATION.links[2].label}
                            </a>
                          </Box> */}
                          <Box className="topnavRightGroupLinks">
                            {HEADER_CONTENT_TOP_NAVIGATION.links?.map(
                              (link: any, i: any) => {
                                if (i > 2) {
                                  return (
                                    <React.Fragment key={link.href+i}>
                                      <div role="listitem"  className="topnavRightGroupLinks">
                                      <a
                                        href={link.href}
                                        onClick={(event: any) =>
                                          anchorTagToggle(event, i)
                                        }
                                        className={
                                          anchorActiveID == i
                                            ? "linkActive"
                                            : ""
                                        }
                                      >
                                        {link.label}
                                      </a>
                                      </div>
                                      <Divider
                                        role="presentation"
                                        orientation="vertical"
                                        flexItem
                                      />
                                    </React.Fragment>
                                  );
                                }
                              }
                            )}
                            {/* <a href={HEADER_CONTENT_TOP_NAVIGATION.links[3].href} onClick={(event: any) => anchorTagToggle(event,HEADER_CONTENT_TOP_NAVIGATION?.links[3]?.label)} className={(anchorActiveID==HEADER_CONTENT_TOP_NAVIGATION?.links[3]?.label) ? "linkActive" : ""}>
                                {HEADER_CONTENT_TOP_NAVIGATION.links[3].label}
                              </a>
                              <Divider orientation="vertical" flexItem role="presentation"/>
                              <a href={HEADER_CONTENT_TOP_NAVIGATION.links[4].href} onClick={(event: any) => anchorTagToggle(event,HEADER_CONTENT_TOP_NAVIGATION?.links[4]?.label)} className={(anchorActiveID==HEADER_CONTENT_TOP_NAVIGATION?.links[4]?.label) ? "linkActive" : ""}>
                                {HEADER_CONTENT_TOP_NAVIGATION.links[4].label}
                              </a> */}
                          </Box>
                        </Box>
                      </Box>
                    </Toolbar>
                  </AppBar>
                   {/*<nav>
                    <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            anchor="right"
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}

                          >
                            {drawer}
                          </Drawer> 
                  </nav>*/}
                </Box>
              </Box>
            </Box>
            <Box className="bottomRow" ref={scrollRef}>
              <Box className="main">
                <Box sx={{ display: "flex" }}>
                  <CssBaseline />
                  <AppBar component="nav" role="navigation" aria-label="Main">
                    <Toolbar>
                      <Box
                        sx={{ display: { xs: "none", sm: "block" } }}
                        className="bottomnav"
                      >
                        <Box className="bottomnavLeftLinks">
                          <a href="https://www.brightspeed.com/#">
                            <img
                              src={HEADER_CONTENT_BOTTOM_NAVIGATION?.logo?.url}
                              alt="Brightspeed Logo"
                            ></img>
                          </a>
                        </Box>
                        
                          <Box className="bottomCenterLinks" role="list">
                            <Box role="listitem" className="supportSection">
                              <a
                                key={HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_internet?.title}
                                href={HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_internet?.href}
                                onClick={(event: any) =>
                                  anchorTagToggle(event)
                                }
                              >
                                {HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_internet?.title}
                              </a>
                            </Box>

                            <Box role="listitem" className="supportSection">
                              <Dropdown open={shopAddOnDropdownOpen} onOpenChange={() => setShopAddOnDropdownOpen(e => !e)}>
                                <MenuButton ref={shopAddOnButtonRef}>{HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_add_ons?.title}</MenuButton>
                                <Menu className="supportDesktop" >
                                  {HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_add_ons?.links.map(
                                    (item: any, i: any) => {
                                      return (
                                        <MenuItem key={item.label} value={item.label} onKeyDown={(event: any) => handleShopAddOnKeyDown(event, i)}>
                                          <a
                                            href={item.href}
                                            onClick={(event: any) =>
                                              anchorTagToggle(event)
                                            }
                                          >
                                            {item.label}
                                          </a>
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </Menu>
                              </Dropdown>
                            </Box>

                            <Box role="listitem" className="supportSection">
                              <a
                                key={HEADER_CONTENT_BOTTOM_NAVIGATION?.Moving?.title}
                                href={HEADER_CONTENT_BOTTOM_NAVIGATION?.Moving?.href}
                                onClick={(event: any) =>
                                  anchorTagToggle(event)
                                }
                              >
                                {HEADER_CONTENT_BOTTOM_NAVIGATION?.Moving?.title}
                              </a>
                            </Box>

                            <Box role="listitem" className="supportSection">
                              <Dropdown open={findSupportDropdownOpen} onOpenChange={() => setFindSupportDropdownOpen(e => !e)}>
                                <MenuButton ref={findSupportButtonRef}>{HEADER_CONTENT_BOTTOM_NAVIGATION?.findsupport?.title}</MenuButton>
                                <Menu className="supportDesktop" >
                                  {HEADER_CONTENT_BOTTOM_NAVIGATION?.findsupport?.links.map(
                                    (item: any, i: any) => {
                                      return (
                                        <MenuItem key={item.label} value={item.label} onKeyDown={(event: any) => handlefindSupportKeyDown(event, i)}>
                                          <a
                                            href={item.href}
                                            onClick={(event: any) =>
                                              anchorTagToggle(event)
                                            }
                                          >
                                            {item.label}
                                          </a>
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </Menu>
                              </Dropdown>
                            </Box>
                          </Box>
                        
                        <Box className="bottomnavRightLinks">
                          <Box className="profileIcon">
                            <img src={profileIcon} alt="user icon"></img>
                            {/* <Typography component="span" className="link-underline">My Brightspeed</Typography> */}
                          </Box>
                          <Dropdown open={myBrightspeedDropdownOpen} onOpenChange={()=> {setMyBrightspeedDropdownOpen(e => !e)}}>
                            <MenuButton ref={myBrightspeedButtonRef}>My Brightspeed</MenuButton>
                            <Menu className="profileDesktop">
                              <Box className="profileLogoSectionDesktop">
                                <img src={profileMobileLogo}></img>
                                <Typography component="span">Login</Typography>
                              </Box>
                              {HEADER_CONTENT_BOTTOM_NAVIGATION?.mybrightspeed?.links.map(
                                (item: any, i: any) => {
                                  return (
                                    <MenuItem onKeyDown={(event: any) => handleMyBrightspeedKeyDown(event, i)} key={item.label} value={item.label}>
                                      <a href={item.href}>{item.label}</a>
                                    </MenuItem>
                                  );
                                }
                              )}
                            </Menu>
                          </Dropdown>
                        </Box>
                      </Box>
                    </Toolbar>
                  </AppBar>
                   {/*<nav>
                    <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            anchor="right"
                            onClose={handleDrawerToggle}
                            ModalProps={{
                              keepMounted: true, // Better open performance on mobile.
                            }}
                            >
                            {drawer}
                          </Drawer> 
                  </nav>*/}
                </Box>
              </Box>
            </Box>
          </Box>
          {mobileOpen && (
            <Box className="sidenavModal" role="navigation">
              <Box className="sidenav" role="list">
                <Box className="mobileTopRow" >
                  <Box className="topLinks">
                    {HEADER_CONTENT_TOP_NAVIGATION.links?.map(
                      (link: any, i: any) => {
                        if (i < 2) {
                          return (
                            <React.Fragment key={link.href+i}>
                              <a  role="listitem"
                                href={link.href}
                                onClick={(event: any) =>
                                  anchorTagToggle(event, i)
                                }
                                className={
                                  anchorActiveID == i ? "linkActive" : ""
                                }
                              >
                                {link.label}
                              </a>
                              <Divider orientation="vertical" flexItem  role="presentation" />
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                    {/* <a href={HEADER_CONTENT_TOP_NAVIGATION.links[0].href} onClick={(event: any) => anchorTagToggle(event)} className={anchorActive ? "linkActive" : ""}>
                        {HEADER_CONTENT_TOP_NAVIGATION.links[0].label}
                      </a>
                      <Divider orientation="vertical" flexItem />
                      <a href={HEADER_CONTENT_TOP_NAVIGATION.links[1].href} onClick={(event: any) => anchorTagToggle(event)} className={anchorActive ? "linkActive" : ""}>
                        {HEADER_CONTENT_TOP_NAVIGATION.links[1].label}
                      </a> */}
                  </Box>
                  {/* Removed Check Availability as per new requirement - May 2025 */}
                  {/* <Box  role="listitem"
                    onClick={(event: any) => anchorCheckAvailability(event)}
                    className={
                      checkAvailabilityActive
                        ? "checkAvailability chacklinkActive"
                        : "checkAvailability"
                    }
                  >
                    <a href={HEADER_CONTENT_TOP_NAVIGATION.links[2].href}>
                      {HEADER_CONTENT_TOP_NAVIGATION.links[2].label}
                    </a>
                  </Box> */}
                </Box>
                <Box className="mobileMiddleRow">
                  <Box className="profileSectionMobile">
                    <Box
                      aria-label="My Brightspeed menu"
                      aria-haspopup="true" 
                      component="button"
                      style={{border:"none", width:"100%"}}
                      className={
                        mobileProfileOpen
                          ? "profileIcon open"
                          : "profileIcon closed"
                      }
                      onClick={handleProfileToggle}
                      aria-expanded={mobileProfileOpen ? "true" : "false"}      

                    >
                      <img src={profileIcon}></img>
                      <Typography component="span" className="link-underline">
                        My Brightspeed
                      </Typography>
                    </Box>
                    {mobileProfileOpen && (
                      <Box className="mobileLinks">
                        <Box className="profileLogoSection">
                          <img src={profileMobileLogo}></img>
                          <Typography component="span">Login</Typography>
                        </Box>

                        <ul>
                          {HEADER_CONTENT_BOTTOM_NAVIGATION?.mybrightspeed?.links.map(
                            (item: any, i: any) => {
                              return (
                                <li key={item.label} value={item.label}>
                                  <a
                                    href={item.href}
                                    onClick={(event: any) =>
                                      anchorTagToggle(event)
                                    }
                                  >
                                    {item.label}
                                  </a>
                                </li>
                              );
                            }
                          )}
                        </ul>
                      </Box>
                    )}
                  </Box>
                  <Box className="mobileCenterLinks">
                    <a role="listitem" href={HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_internet?.href}>{HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_internet?.title}</a>
                    <Box className="supportSection">
                      <Box
                       aria-label="Shop add ons menu"
                       aria-haspopup="true"
                       component="button" 
                       style={{border:"none", textAlign:"left"}}
                        className={
                          mobileShopAddonOpen ? "support open" : "support closed"
                        }
                        onClick={()=>{handleSupportToggle(setMobileShopAddonOpen)}}
                        aria-expanded={mobileShopAddonOpen ? "true" : "false"}>
                        <Typography component="span" className="link-underline" >
                          {HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_add_ons?.title}
                        </Typography>
                      </Box>
                       {mobileShopAddonOpen && (
                        <ul className="supportLinksMobile">
                          {HEADER_CONTENT_BOTTOM_NAVIGATION?.Shop_add_ons?.links.map(
                            (item: any, i: any) => {
                              return (
                                <li key={item.label} value={item.label}>
                                  <a
                                    href={item.href}
                                    onClick={(event: any) =>
                                      anchorTagToggle(event)
                                    }
                                  >
                                    {item.label}
                                  </a>
                                </li>
                              );
                            }
                          )}
                        </ul>
                      )}
                    </Box>
                    <a role="listitem" href={HEADER_CONTENT_BOTTOM_NAVIGATION?.Moving?.href}>{HEADER_CONTENT_BOTTOM_NAVIGATION?.Moving?.title}</a>
                    <Box className="supportSection">
                      <Box
                       aria-label="find support menu"
                       aria-haspopup="true"
                       component="button" 
                       style={{border:"none", textAlign:"left"}}
                        className={
                          mobileSupportOpen ? "support open" : "support closed"
                        }
                        onClick={()=>{handleSupportToggle(setMobileSupportOpen)}}
                        aria-expanded={mobileSupportOpen ? "true" : "false"}>
                        <Typography component="span" className="link-underline" >
                          Find support
                        </Typography>
                      </Box>
                       {mobileSupportOpen && (
                        <ul className="supportLinksMobile">
                          {HEADER_CONTENT_BOTTOM_NAVIGATION?.findsupport?.links.map(
                            (item: any, i: any) => {
                              return (
                                <li key={item.label} value={item.label}>
                                  <a
                                    href={item.href}
                                    onClick={(event: any) =>
                                      anchorTagToggle(event)
                                    }
                                  >
                                    {item.label}
                                  </a>
                                </li>
                              );
                            }
                          )}
                        </ul>
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box className="mobileBottomRow">
                  <a role="listitem"
                    href={HEADER_CONTENT_TOP_NAVIGATION.links[3].href}
                    target="_blank"
                  >
                    {HEADER_CONTENT_TOP_NAVIGATION.links[3].label}
                  </a>
                  <a role="listitem"
                    href={HEADER_CONTENT_TOP_NAVIGATION.links[4].href}
                    target="_blank"
                  >
                    {HEADER_CONTENT_TOP_NAVIGATION.links[4].label}
                  </a>
                </Box>
              </Box>
            </Box>
          )}
        </Stack>
        </header>
      )}
    </Stack>
  );
};
export default LoginHeader;
